<template>
  <v-app>
    <v-app-bar
        app
        color="primary"
        dark
    >
      SLES AutoYast Template Builder
      <v-spacer></v-spacer>
      <router-link to="logout" class="text-decoration-none" style="color: white !important;">{{ version }}</router-link>
    </v-app-bar>
    <v-main>
      <SLESForm/>
    </v-main>
  </v-app>
</template>

<script>
import SLESForm from '@/components/SLESForm'
import axios from "@/utils/axios"

export default {
  name: 'App',

  components: {
    SLESForm
  },

  created() {
    axios.get("/api/v1/version")
        .then(resp => (this.version = resp.data.version));
  },

  data: () => ({
    version: 'latest'
  }),
};
</script>
